const actions = {
  REQUEST_CREATED: "REQUEST_CREATED",
};

export default actions;
